import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    tabs: {
        position: 'sticky',
        // Sit just below the fixed app header (~64px) with a small gap so the bar
        // reads as a detached, floating element rather than fused to the header.
        top: 68,
        zIndex: 9,
        // Liquid-glass effect: translucent fill + backdrop blur so the content
        // scrolling underneath shows through with a frosted feel.
        background: 'rgba(255, 255, 255, 0.55)',
        backdropFilter: 'saturate(180%) blur(24px)',
        WebkitBackdropFilter: 'saturate(180%) blur(24px)',
        borderRadius: 4,
        boxShadow: '0 6px 20px rgba(0, 0, 40, 0.08)',
        border: '1px solid rgba(0, 0, 40, 0.06)',
        display: 'flex',
        alignItems: 'center',
        padding: '0 12px',
        marginBottom: 16,
    },
    tab: {
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        fontFamily: 'inherit',
        fontSize: 13,
        fontWeight: 500,
        color: '#6b6b7a',
        padding: '12px 16px',
        borderBottom: '2px solid transparent',
        marginBottom: -1,
        '&:hover': {
            color: '#1a1a2f',
        },
    },
    tabActive: {
        color: theme.palette.primary.main,
        borderBottomColor: theme.palette.primary.main,
        fontWeight: 600,
    },
}));
